export default function toCamelCase(string) {
  return string.replace(/_([a-z])/g, g => g[1].toUpperCase());
}